import gql from 'graphql-tag'

export const QUERY_GET_PRODUCTS_AND_GROUPS = gql`
  query Products($search: String, $ids: [String], $skus: [String], $active: Boolean) {
    products(search: $search, ids: $ids, skus: $skus, active: $active) {
      products {
        _id
        sku
        ean
        eans
        name
      }
    }
    productsGroups(search: $search) {
      productsGroups {
        _id
        name
        products {
          _id
          sku
          ean
          eans
          name
        }
      }
    }
  }
`

export const QUERY_GET_CAMPAIGN_BY_ID = gql`
  query Campaign($id: ID!) {
    campaign(_id: $id) {
      _id
      title
      status
      description
      ... on WhatsappChannelCampaign {
        senders {
          name
          number
        }
        targeting_mode
      }
      initial_date
      final_date
      segments {
        _id
        name
        clients_qty
        updated_at
        clients_refreshed_at
      }
      products {
        sku
        name
      }
      message {
        send_date
        send_time
        subject
        ... on EmailChannelCampaignMessage {
          processed_html
          email_configuration_type
          simple_email_configuration {
            text
            subject
            header_image
            image
            click_to_call_button_text
            click_to_call_button_link
            footer
          }
          html_email_configuration {
            has_uploaded_file
            filename
            url
            uploaded_at
          }
          builder_email_configuration
        }
      }
    }
  }
`

export const QUERY_NUMBER_OF_CONTACTS = gql`
  query GetNumberOfContacts($active: Boolean, $senders: [String]) {
    getNumberOfContacts(active: $active, senders: $senders) {
      total
      loyalty
      non_loyalty
    }
  }
`

export const QUERY_UPSERT_DRAFT_OMNI_CAMPAIGN = gql`
  mutation UpsertDraftOmniCampaign($data: OmniCampaignDraftInput!) {
    upsertDraftOmniCampaign(data: $data) {
      _id
      message
    }
  }
`

export const QUERY_UPSERT_OMNI_CAMPAIGN = gql`
  mutation UpsertOmniCampaign($data: OmniCampaignInput!) {
    upsertOmniCampaign(data: $data) {
      _id
      message
    }
  }
`

export const QUERY_GET_OMNI_CAMPAIGN = gql`
  query OmniCampaign($id: ID!) {
    omniCampaign(_id: $id) {
      _id
      title
      status
      description
      units {
        id_erp
        name
        dataType
      }
      segments {
        _id
        name
        description
        version
        clients_qty
        campaign_qty
      }
      client_targets_distribution {
        actives
        recent_inactives
        losses
        at_risk
        never_bought
      }
      product_targets {
        repurchase
        upsell
      }
      advanced_configuration {
        multiple_channels_per_consumer
        multiple_messages_per_consumer
      }
      channels {
        email {
          active
          budget
          message {
            send_time
            send_date
            subject
            processed_html
            email_configuration_type
            simple_email_configuration {
              text
              subject
              header_image
              image
              click_to_call_button_text
              click_to_call_button_link
              footer
            }
            html_email_configuration {
              has_uploaded_file
              filename
              url
              uploaded_at
            }
            builder_email_configuration
          }
        }
        whatsapp {
          active
          budget
          senders {
            name
            number
          }
          targeting_mode
          message {
            send_time
            send_date
            text
            attachment {
              data_url
              thumbnail_url
              mimetype
              filename
            }
          }
        }
        push {
          active
          budget
          message {
            text
            send_time
            send_date
            inner_message_text
            inner_message_title
            title
            image_url
            action {
              type
              link
              reference_id
            }
          }
        }
        sms {
          active
          budget
          message {
            text
            send_time
            send_date
          }
        }
      }
      initial_date
      start_time
      final_date
      end_time
      offer_schedule {
        _id
        finalized
        description
        departments {
          _id
          name
        }
        segments {
          name
        }
        offer_sales {
          ... on CampaignOfferSale {
            sku
            name
            ean
            eans
            product {
              sku
              name
            }
          }
          ... on CampaignOfferSalesGroup {
            _id
            name
            image_url
            group_image_url
            group_rules_exhibition
            offer_sales {
              name
              sku
              ean
              eans
              image_url
            }
          }
        }
        percentage_offer_sales {
          ... on CampaignOfferSalePercentage {
            name
            sku
            active
            ean
            eans
            percentage_discount
            maximum_per_client
            minimum_per_client
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on CampaignOfferSalesPercentageGroup {
            _id
            name
            percentage_discount
            maximum_per_client
            minimum_per_client
            image_url
            group_image_url
            group_rules_exhibition
            percentage_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              product {
                eans
                ean
                image_url
              }
            }
          }
        }
        takepay_offer_sales {
          ... on CampaignOfferSaleTakeAndPay {
            name
            sku
            active
            ean
            eans
            take
            pay
            maximum_per_client
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on CampaignOfferSalesTakeAndPayGroup {
            _id
            name
            take
            pay
            maximum_per_client
            image_url
            group_image_url
            group_rules_exhibition
            takepay_offer_sales {
              name
              sku
              active
              ean
              eans
              finalized
              image_url
              product {
                eans
                ean
                image_url
              }
            }
          }
        }
        combo_offer_sales {
          name
          active
          maximum_per_client
          discount_by_count
          image
          trigger_products {
            ... on CampaignTriggerProduct {
              quantity
              name
              sku
              ean
              eans
              product {
                sku
                ean
                eans
                name
              }
            }
            ... on CampaignTriggerProductGroup {
              _id
              name
              quantity
              trigger_products {
                name
                sku
                ean
                eans
                product {
                  _id
                  sku
                  ean
                  eans
                  name
                }
              }
            }
          }
          target_products {
            ... on CampaignTargetProduct {
              percentage_discount
              name
              sku
              ean
              eans
              product {
                sku
                ean
                eans
                name
              }
            }
            ... on CampaignTargetProductGroup {
              _id
              name
              percentage_discount
              target_products {
                name
                sku
                ean
                eans
              }
            }
          }
        }
      }
      offer_sales {
        ... on CampaignOfferSale {
          name
          sku
          ean
          eans
          price_1
          price_2
          active
          product {
            sku
            ean
            eans
            name
          }
        }
        ... on CampaignOfferSalesGroup {
          _id
          name
          price_1
          price_2
          image_url
          group_image_url
          group_rules_exhibition
          offer_sales {
            name
            sku
            ean
            eans
            active
            image_url
            product {
              sku
              ean
              eans
              name
              image_url
            }
          }
        }
      }
      percentage_offer_sales {
        ... on CampaignOfferSalePercentage {
          name
          sku
          active
          ean
          eans
          percentage_discount
          maximum_per_client
          minimum_per_client
          product {
            sku
            ean
            eans
            name
          }
        }
        ... on CampaignOfferSalesPercentageGroup {
          _id
          name
          percentage_discount
          maximum_per_client
          minimum_per_client
          image_url
          group_image_url
          group_rules_exhibition
          percentage_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            product {
              eans
              ean
              image_url
            }
          }
        }
      }
      takepay_offer_sales {
        ... on CampaignOfferSaleTakeAndPay {
          name
          sku
          active
          ean
          eans
          take
          pay
          maximum_per_client
          product {
            sku
            ean
            eans
            name
          }
        }
        ... on CampaignOfferSalesTakeAndPayGroup {
          _id
          name
          take
          pay
          maximum_per_client
          image_url
          group_image_url
          group_rules_exhibition
          takepay_offer_sales {
            name
            sku
            active
            ean
            eans
            finalized
            image_url
            product {
              eans
              ean
              image_url
            }
          }
        }
      }
      combo_offer_sales {
        name
        maximum_per_client
        discount_by_count
        image
        active
        trigger_products {
          ... on CampaignTriggerProduct {
            quantity
            name
            sku
            ean
            eans
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on CampaignTriggerProductGroup {
            _id
            name
            quantity
            trigger_products {
              name
              sku
              ean
              eans
              product {
                _id
                sku
                ean
                eans
                name
              }
            }
          }
        }
        target_products {
          ... on CampaignTargetProduct {
            percentage_discount
            name
            sku
            ean
            eans
            product {
              sku
              ean
              eans
              name
            }
          }
          ... on CampaignTargetProductGroup {
            _id
            name
            percentage_discount
            target_products {
              name
              sku
              ean
              eans
            }
          }
        }
      }
    }
  }
`

export const QUERY_LIST_OMNI_CAMPAIGNS = gql`
  query OmniCampaigns($search: String, $page: Int, $status: [OmniCampaignStatus], $pageSize: Int, $sort: [String], $sortDirection: [SortDirection]) {
    omniCampaigns(page: $page, pageSize: $pageSize, status: $status, search: $search, sort: $sort, sortDirection: $sortDirection) {
      omni_campaigns {
        _id
        title
        description
        status
        products_count
        has_inactive_products
        channels {
          email {
            active
          }
          whatsapp {
            active
          }
          push {
            active
          }
          sms {
            active
          }
        }
        units {
          name
        }
        initial_date
        final_date
        updated_at
      }
      page
      records
    }
  }
`

export const QUERY_DELETE_OMNI_CAMPAIGN = gql`
  mutation DeleteOmniCampaign($id: ID!) {
    deleteOmniCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const QUERY_UNSCHEDULE_OMNI_CAMPAIGN = gql`
  mutation UnscheduleOmniCampaign($id: ID!) {
    unscheduleOmniCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const QUERY_METRICS_OMNI_CAMPAIGN = gql`
  query OmniCampaignMetrics($id: ID!) {
    omniCampaign(_id: $id) {
      metrics {
        clients_metrics {
          general {
            identified {
              count
              revenue
              tickets
              average_ticket
            }
            received {
              count
              revenue
              tickets
              average_ticket
            }
            received_and_bought {
              count
              revenue
              tickets
              average_ticket
            }
            received_with_products {
              count
              revenue
              tickets
              average_ticket
            }
            received_with_only_products {
              count
              revenue
              tickets
              average_ticket
            }
          }
          channels {
            email {
              sent {
                count
              }
            }
            push {
              sent {
                count
              }
            }
            whatsapp {
              sent {
                count
              }
            }
            sms {
              identified {
                count
                revenue
                tickets
                average_ticket
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
            }
          }
        }
        products_metrics {
          related_table {
            product {
              sku
              name
            }
            tickets
            total_tickets
          }
        }
        analytic_metrics {
          general {
            credits
            sending_credits
            validation_credits
            price
            sending_price
            validation_price
            received_roi
            opened_roi
            average_ticket_received_variation
          }
        }
      }
    }
  }
`

export const QUERY_CHANNELS_METRICS_OMNI_CAMPAIGN = gql`
  query OmniCampaignChannelsMetrics($id: ID!) {
    omniCampaign(_id: $id) {
      metrics {
        clients_metrics {
          channels {
            email {
              identified {
                count
                revenue
                tickets
                average_ticket
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
            }
            push {
              identified {
                count
                revenue
                tickets
                average_ticket
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
            }
            sms {
              identified {
                count
                revenue
                tickets
                average_ticket
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
            }
            whatsapp {
              identified {
                count
                revenue
                tickets
                average_ticket
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
            }
          }
        }
        analytic_metrics {
          channels {
            whatsapp {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
            sms {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
            push {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
            email {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
          }
        }
      }
    }
  }
`

export const QUERY_METRICS_OMNI_CAMPAIGN_BY_UNITS = gql`
  query OmniCampaignMetricsByUnits($id: ID!, $units: [String]) {
    omniCampaign(_id: $id) {
      metrics(units: $units) {
        clients_metrics {
          before_bought {
            received {
              actives
              at_risk
              losses
              never_bought
              recent_inactives
            }
            received_and_bought {
              actives
              at_risk
              losses
              never_bought
              recent_inactives
            }
            received_with_only_products {
              actives
              at_risk
              losses
              recent_inactives
              never_bought
            }
            received_with_products {
              actives
              at_risk
              losses
              never_bought
              recent_inactives
            }
          }
          general {
            identified {
              count
              revenue
              tickets
              average_ticket
            }
            received {
              count
              revenue
              tickets
              average_ticket
            }
            received_and_bought {
              count
              revenue
              tickets
              average_ticket
            }
            received_with_products {
              count
              revenue
              tickets
              average_ticket
            }
            received_with_only_products {
              count
              revenue
              tickets
              average_ticket
            }
            total {
              revenue
            }
          }
          channels {
            email {
              sent {
                count
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
              total {
                revenue
              }
            }
            push {
              sent {
                count
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
              total {
                revenue
              }
            }
            whatsapp {
              sent {
                count
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
              total {
                revenue
              }
            }
            sms {
              sent {
                count
              }
              identified {
                count
                revenue
                tickets
                average_ticket
              }
              received {
                count
                revenue
                tickets
                average_ticket
              }
              received_and_bought {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_products {
                count
                revenue
                tickets
                average_ticket
              }
              received_with_only_products {
                count
                revenue
                tickets
                average_ticket
              }
              total {
                revenue
              }
            }
          }
        }
        general_metrics {
          channels {
            email {
              received {
                messages
              }
              received_and_bought {
                messages
              }
              received_with_only_products {
                messages
              }
              received_with_products {
                messages
              }
              sent {
                messages
              }
            }
            push {
              received {
                messages
              }
              received_and_bought {
                messages
              }
              received_with_only_products {
                messages
              }
              received_with_products {
                messages
              }
              sent {
                messages
              }
            }
            sms {
              received {
                messages
              }
              received_and_bought {
                messages
              }
              received_with_only_products {
                messages
              }
              received_with_products {
                messages
              }
              sent {
                messages
              }
            }
            whatsapp {
              received {
                messages
              }
              received_and_bought {
                messages
              }
              received_with_only_products {
                messages
              }
              received_with_products {
                messages
              }
              sent {
                messages
              }
            }
          }
        }
        analytic_metrics {
          channels {
            whatsapp {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
            sms {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
            push {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
            email {
              credits
              sending_credits
              validation_credits
              price
              sending_price
              validation_price
              received_roi
              opened_roi
              average_ticket_received_variation
            }
          }
          general {
            credits
            sending_credits
            validation_credits
            price
            sending_price
            validation_price
            received_roi
            opened_roi
            average_ticket_received_variation
          }
        }
        products_metrics {
          related_table {
            product {
              sku
              name
            }
            tickets
            total_tickets
          }
          table {
            opened {
              clients
              quantity
              revenue
              tickets
            }
            product {
              sku
              name
              _id
            }
            received {
              clients
              quantity
              revenue
              tickets
            }
            total {
              clients
              quantity
              revenue
              tickets
            }
            message_received {
              clients
            }
            received_upsell {
              clients
              quantity
              revenue
              tickets
            }
            opened_upsell {
              clients
              quantity
              revenue
              tickets
            }
            total_upsell {
              clients
              quantity
              revenue
              tickets
            }
          }
          totals {
            opened {
              clients
              quantity
              revenue
              tickets
            }
            received {
              clients
              quantity
              revenue
              tickets
            }
            total {
              clients
              quantity
              revenue
              tickets
            }
            message_received {
              clients
            }
            received_upsell {
              clients
              quantity
              revenue
              tickets
            }
            opened_upsell {
              clients
              quantity
              revenue
              tickets
            }
            total_upsell {
              clients
              quantity
              revenue
              tickets
            }
          }
        }
      }
    }
  }
`

export const QUERY_CHANNEL_SHOOTING_HISTORY = gql`
  query MessagesHistory($id: ID!, $page: Int, $pageSize: Int, $channels: [ChannelEnum], $sort: [String], $sortDirection: [SortDirection]) {
    messagesHistory(_id: $id, page: $page, pageSize: $pageSize, channels: $channels, sort: $sort, sortDirection: $sortDirection) {
      messages_history {
        client_id
        contact
        content
        date
        price
        status
      }
      records
      page
    }
  }
`

export const QUERY_FINISH_OMNI_CAMPAIGN = gql`
  mutation FinishOmniCampaign($id: ID!) {
    finishOmniCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const QUERY_AGGREGATED_CLIENTS_STATUS_INFO = gql`
  query GetAggregatedClientStatusInfo($segments_ids: [ID!]!) {
    getAggregatedClientStatusInfo(segments_ids: $segments_ids) {
      all {
        client_active_count
        client_at_risk_count
        client_losses_count
        client_never_bought_count
        client_recent_inactive_count
        total_count
      }
    }
  }
`

export const QUERY_GET_MESSAGE_BY_TYPE = gql`
  query GetMessageByType {
    getMessageByType(type: OPTOUT_SUFFIX) {
      interpolated_text
      active
    }
  }
`

export const QUERY_V2_SELECT = gql`
  query OmniCampaignV2Select($id: ID!, $units: [String]) {
    omniCampaign(_id: $id) {
      metrics(units: $units) {
        clients_metrics {
          before_bought {
            received {
              active
              inactive
              lost
              never_bought
            }
            received_and_bought {
              active
              inactive
              lost
              never_bought
            }
            received_with_products {
              active
              inactive
              lost
              never_bought
            }
            received_with_only_products {
              active
              inactive
              lost
              never_bought
            }
          }
        }
      }
    }
  }
`

export const QUERY_GET_OMNI_CAMPAIGN_TICKETS_BY_HOURS = gql`
  query OmniCampaignTicketsByHour($id: ID!, $units: [String]) {
    omniCampaignTicketsByHour(_id: $id, units: $units) {
      metrics {
        hour
        received {
          tickets
        }
        received_and_bought {
          tickets
        }
        received_with_products {
          tickets
        }
        received_with_only_products {
          tickets
        }
      }
    }
  }
`

export const QUERY_GET_OMNI_CAMPAIGN_TICKETS_BY_GENDER_AND_AGE = gql`
  query OmniCampaignAverageTicketByGenderAndAge($id: ID!, $units: [String]) {
    omniCampaignAverageTicketByGenderAndAge(_id: $id, units: $units) {
      metrics {
        age_range
        received {
          female {
            average_ticket
            clients
          }
          male {
            average_ticket
            clients
          }
          unknown_gender {
            average_ticket
            clients
          }
        }
        received_and_bought {
          female {
            average_ticket
            clients
          }
          male {
            average_ticket
            clients
          }
          unknown_gender {
            average_ticket
            clients
          }
        }
        received_with_only_products {
          female {
            average_ticket
            clients
          }
          male {
            average_ticket
            clients
          }
          unknown_gender {
            average_ticket
            clients
          }
        }
        received_with_products {
          female {
            average_ticket
            clients
          }
          male {
            average_ticket
            clients
          }
          unknown_gender {
            average_ticket
            clients
          }
        }
      }
      totals {
        received {
          female {
            clients
          }
          male {
            clients
          }
          unknown_gender {
            clients
          }
        }
        received_and_bought {
          female {
            clients
          }
          male {
            clients
          }
          unknown_gender {
            clients
          }
        }
        received_with_only_products {
          female {
            clients
          }
          male {
            clients
          }
          unknown_gender {
            clients
          }
        }
        received_with_products {
          female {
            clients
          }
          male {
            clients
          }
          unknown_gender {
            clients
          }
        }
      }
    }
  }
`

export const QUERY_GET_OMNI_CAMPAIGN_CHANNELS_ITEMS = gql`
  query OmniCampaignAverageItemsByClientMessageReceiving($id: ID!, $units: [String]) {
    omniCampaignAverageItemsByClientMessageReceiving(_id: $id, units: $units) {
      metrics {
        average_items_range
        received_and_bought_clients
        not_received_and_bought_clients
      }
    }
  }
`

export const QUERY_GET_METRICS = gql`
  query MetricsKpi($initialDate: String!, $finalDate: String!, $groupBy: MetricGroupBy, $units: [ID], $campaignIds: [ID], $productIds: [String]) {
    metricsKpi(initialDate: $initialDate, finalDate: $finalDate, units: $units, campaignIds: $campaignIds, productIds: $productIds, groupBy: $groupBy) {
      revenue {
        value
        date
      }
      total_coupons {
        value
        date
      }
    }
  }
`

export const QUERY_CLONE_OMNI_CAMPAIGN = gql`
  mutation CloneOmniCampaign($id: ID!) {
    cloneOmniCampaign(_id: $id) {
      _id
      message
    }
  }
`

export const QUERY_GET_AGGREGATED_CLIENTS_STATUS_INFO = gql`
  query GetAggregatedClientStatusInfo($segments_ids: [ID!]) {
    getAggregatedClientStatusInfo(segments_ids: $segments_ids) {
      email {
        client_active_count
        client_at_risk_count
        client_losses_count
        client_never_bought_count
        client_recent_inactive_count
        total_count
      }
      push {
        client_active_count
        client_at_risk_count
        client_losses_count
        client_never_bought_count
        client_recent_inactive_count
        total_count
      }
      sms {
        client_active_count
        client_at_risk_count
        client_losses_count
        client_never_bought_count
        client_recent_inactive_count
        total_count
      }
      whatsapp {
        client_active_count
        client_active_count
        client_at_risk_count
        client_losses_count
        client_never_bought_count
        client_recent_inactive_count
        client_non_loyalty_count
        total_count
      }
    }
  }
`
